import { memo } from "react";
import MatchTinyStandard from "./MatchTinyStandard";
import MatchTinyArena from "./MatchTinyArena";
import MatchNone from "./MatchNone";

export const MatchTiny = ({ region, puuid, data, width }) => {
  return (
    <>
      {[1810, 1820, 1830, 1840].includes(data.queue) && (
        <MatchNone region={region} puuid={puuid} data={data} width={width} />
      )}
      {(data.queue === 1700 || data.queue === 1710) && (
        <MatchTinyArena
          region={region}
          puuid={puuid}
          data={data}
          width={width}
        />
      )}
      {![1700, 1710, 1810, 1820, 1830, 1840].includes(data.queue) && (
        <MatchTinyStandard
          region={region}
          puuid={puuid}
          data={data}
          width={width}
        />
      )}
    </>
  );
};

export default memo(MatchTiny);
